import { createContext } from 'react';

const PaymentMethodContext = createContext(null);

export { PaymentMethodContext };
